// extracted by mini-css-extract-plugin
module.exports = {"root":"AuthModal_root__2bg_A","buttonGroup":"AuthModal_buttonGroup__IfiSS","backDrop":"AuthModal_backDrop__35dNs"};